<template>
    <div class="main-page">
        <mobileHeader></mobileHeader>
        <mobileSidebar></mobileSidebar>
        <fixedHeader></fixedHeader>
        <formModal :class="{open: isOpenFormModal}"></formModal>
        <secretBtns :class="{fadeIn: fadeInVisible}"></secretBtns>
        <indexPromo></indexPromo>
        <about></about v-if="DomLoaded">
        <formTop v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }" v-if="DomLoaded"></formTop>
        <!-- <flats v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }"></flats> -->
        <CRMflats v-if="salesCardPage != null && setup != null"></CRMflats>
        <gallery v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }"></gallery>
        <news></news>
        <formBottom v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }" v-if="DomLoaded"></formBottom>
        <contacts v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }"></contacts>
        <div class="global-overlay" :class="{open: isOpenSendwich}" @click="closeMobileMenu(!isOpenSendwich)">
            <!-- <div class="global-overlay-ripple" :class="{animatedEnd: animatedEnd}"></div> -->
        </div>
    </div>
</template>

<script>
    import indexPromo from '@/components/index-promo/index-promo.vue'
    import about from '@/components/about/about.vue'
    import CRMflats from '@/components/flats-crm/flats-crm-section.vue'
    // import flats from '@/components/flats/flats.vue'
    import news from '@/components/news/news.vue'
    import gallery from '@/components/gallery/gallery.vue'
    import contacts from '@/components/contacts/contacts.vue'
    import formTop from '@/components/forms/form-top.vue'
    import formBottom from '@/components/forms/form-bottom.vue'
    import formModal from '@/components/forms/form-modal.vue'
    import secretBtns from '@/components/partials/secret-btns.vue'
    import fixedHeader from '@/components/header-fixed/header-fixed.vue'
    import mobileHeader from '@/components/header/mobile-header.vue'
    import mobileSidebar from '@/components/nav-main/mobile-nav-main.vue'
    import {mapGetters} from 'vuex'
    export default {
        name: 'main--page',
        components: {
            indexPromo,
            about,
            // flats,
            CRMflats,
            news,
            gallery,
            contacts,
            formTop,
            formBottom,
            formModal,
            secretBtns,
            fixedHeader,
            mobileHeader,
            mobileSidebar,
        },
        data () {
            return {
                // title: 'Главная',
                intersectionOptions: {
                    rootMargin: '0px 0px 0px 0px',
                    threshold: [0.15,0.75]
                },
                fadeInVisible: false,
                DomLoaded: false
            }
        },
        computed: mapGetters({
            setup: 'loadPageSetup',
            salesCardPage: 'loadSalesCardPage',
            isOpenFormModal: 'loadOpenFormModal',
            isOpenSendwich: 'loadOpenSendwich',
        }),
        methods: {
            onWaypoint ({ el, going, direction }) {
                if (this.$waypointMap.GOING_IN === going) {
                    el.classList.add('active');
                }
            },
            handleScroll () {
                if (window.scrollY >= 1500) {
                    this.fadeInVisible = true;
                } else {
                    this.fadeInVisible = false;
                }
            },
            removeLoaderPage() {
                var _self = this;
                var loader = $('.loader');
                loader.fadeOut(300);
                window.body.removeClass('overlay-open');
                setTimeout(function(){
                    loader.remove();
                },300);
            },
            closeMobileMenu(param) {
                this.$store.commit('Open_Sendwich', param);
            }
        },
        beforeCreate() {
        },
        created () {
            // document.title = this.title;
            window.addEventListener('scroll', this.handleScroll);
        },
        destroyed() {
            window.removeEventListener('scroll', this.handleScroll);
        },
        mounted() {
            this.$store.watch(
                (state) => state.indexPromo,
                (newValue) => {
                    if (newValue != null) {
                        var _self = this;
                        var image = new Image();
                        image.onload = function () {
                            _self.DomLoaded = true
                            _self.removeLoaderPage();
                        }
                        image.src = newValue.index_promo_images.img_day;
                    }
                }
            )
        }
    }
</script>